import { LiveKitRoom, VideoConference } from "@livekit/components-react";
import "@livekit/components-styles";
import { Button } from "../ui/button";
import { Video } from "lucide-react";
import { toast } from "sonner";
import VideoTokenBridge from "./VideoTokenBridge";
import WhisperControls from "./WhisperControls";
import WhisperBar from "./WhisperBar";
import PushToTalkControl from "./PushToTalkControl";
import { useGameStore } from "../../store/gameStore";

export default function VoicePanel({ gameId, status, connection, joining, onJoin, onDisconnected, isGm, myUserId, myMemberId, members }) {
  const sendWs = useGameStore((s) => s.sendWs);
  if (status === null) return <div className="p-8 text-center text-[#f1e0c5]/40">Checking voice/video setup…</div>;

  if (!status) {
    return (
      <div className="p-8 h-full flex flex-col items-center justify-center text-center gap-3" data-testid="voice-not-configured">
        <Video className="w-8 h-8 text-[#f1e0c5]/30" />
        <p className="text-sm text-[#f1e0c5]/50">Voice &amp; video isn't set up yet.</p>
        <p className="text-xs text-[#f1e0c5]/30">The GM needs to add LiveKit Cloud credentials (LIVEKIT_URL / API KEY / SECRET) to enable this table's voice chat.</p>
      </div>
    );
  }

  if (connection) {
    return (
      <div className="h-full flex flex-col" data-testid="voice-room-active">
        <LiveKitRoom
          serverUrl={connection.serverUrl}
          token={connection.token}
          connect
          audio
          video={false}
          data-lk-theme="default"
          style={{ height: "100%", width: "100%", display: "flex", flexDirection: "column" }}
          onDisconnected={onDisconnected}
          onError={(err) => toast.error(`Voice/video connection error: ${err.message || "could not connect"}`)}
        >
          <VideoTokenBridge />
          <WhisperControls myUserId={myUserId} />
          <PushToTalkControl />
          <div className="flex-1 min-h-0"><VideoConference /></div>
          {isGm && <WhisperBar myUserId={myUserId} myMemberId={myMemberId} members={members} sendWs={sendWs} />}
        </LiveKitRoom>
      </div>
    );
  }

  return (
    <div className="p-8 h-full flex flex-col items-center justify-center gap-4">
      <Video className="w-8 h-8 text-[#D4AF37]" />
      <Button data-testid="join-voice-button" onClick={onJoin} disabled={joining} className="rounded-full bg-[#D90429] hover:bg-[#b8031f] uppercase tracking-widest text-xs">
        {joining ? "Connecting…" : "Join Voice & Video"}
      </Button>
    </div>
  );
}
